import { z } from 'zod';

import { CoolingMethod } from '../fields';
import { Humidity } from '../fields/Humidity';
import { IngressProtection } from '../fields/IngressProtection';
import { Length } from '../fields/Length';
import { Temperature } from '../fields/Temperature';

const environmentalBase = z.object({
    operatingTemperature: Temperature.validator.default({}),
    storageTemperature: Temperature.validator.default({}),
    operatingHumidity: Humidity.validator.default({}),
    storageHumidity: Humidity.validator.default({}),
    ingressProtection_IP: IngressProtection.IP.validator,
    ingressProtection_NEMA: IngressProtection.NEMA.validator,
    maximumOperatingAltitude: Length.validator.default({}),
});

export const environmental = environmentalBase.default({});

export const environmentalWithCoolingMethod = environmentalBase
    .merge(
        z.object({
            coolingMethod: CoolingMethod.validator.optional().default('none'),
        }),
    )
    .default({});
